<template>
  <div class="text_background">
    <Card
      :showCard="showCard"
      :cardColor="'route_background'"
      topDistance="(100vh - 500px)"
      :titleContainerHeight="true"
      bottomDistance="100px"
    >
      <template #background="{ step }">
        <div :class="mapContainer(step)">
          <div id="google_map">
            <GmapMap
              :center="{
                lat: parseFloat(pois[0].latitude),
                lng: parseFloat(pois[0].longitude),
              }"
              :zoom="15"
              :options="mapOptions"
              :class="mapStyle(step)"
              ref="mapRef"
            >
              <gmap-polyline
                v-if="
                  currentTour.id != 8 &&
                  currentTour.id != 16 &&
                  currentTour.id != 17 &&
                  currentTour.id != 18
                "
                v-bind:path.sync="polyline"
                v-bind:options="{ strokeColor: '#333333' }"
              >
              </gmap-polyline>
              <gmap-custom-marker
                v-for="poi in pois"
                :key="poi.name"
                :marker="{
                  lat: parseFloat(poi.latitude),
                  lng: parseFloat(poi.longitude),
                }"
                :zIndex="2"
                class="mt-2"
              >
                <button>
                  <img
                    v-if="poi.id == currentPoi.id"
                    src="@/assets/icons/map/poi-active.svg"
                    style="height: 15px; width: auto"
                  />
                  <img
                    v-else
                    src="@/assets/icons/map/poi.svg"
                    style="height: 15px; width: auto"
                  />
                </button>
              </gmap-custom-marker>

              <gmap-custom-marker
                :marker="{
                  lat: parseFloat(location.latitude),
                  lng: parseFloat(location.longitude),
                }"
                :zIndex="1"
              >
                <button>
                  <img
                    src="@/assets/icons/map/user-location.svg"
                    style="height: 32px; width: auto"
                  />
                </button>
              </gmap-custom-marker>
            </GmapMap>
          </div>
          <transition name="fade">
            <div
              v-if="step == 1"
              class="poi-header d-flex align-center justify-center"
              :style="buttontop"
            >
              <img
                src="@/assets/icons/map/user-location.svg"
                style="height: 25px; width: auto"
                class="mr-4"
              />
              <div>{{ $t("tour.go_to_the_station") }}</div>
            </div>
          </transition>

          <div
            style="
              z-index: 100;
              row-gap: 8px;
              position: absolute;
              bottom: 20px;
              right: 10px;
            "
            :style="$vuetify.breakpoint.xs ? 'right: 10px' : 'right: 30px'"
            class="d-flex flex-column align-end"
          >
            <button style="margin-top: auto">
              <img
                src="@/assets/icons/map/North Button.svg"
                style="height: 35px; width: auto"
              />
            </button>
            <button @click="recenter" style="visibility: visible">
              <img
                src="@/assets/icons/map/Location Button.svg"
                style="height: 35px; width: auto"
              />
            </button>
          </div>
        </div>
      </template>

      <template #title="{ step }">
        <!-- title container  -->
        <div
          :class="titleContainerStyle(step)"
          class="d-flex align-center justify-center"
          :style="step == 3 || step == 0 ? titleinset : ''"
        >
          <button
            :style="step == 3 ? 'top: 7px' : ''"
            @click="previousPoi"
            class="mb-4 ml-5"
          >
            <img
              src="@/assets/icons/previous.svg"
              style="height: 18px; width: auto"
              :style="isFirst ? 'opacity: 0.3' : ''"
            />
          </button>
          <div class="d-flex flex-column pl-10 pr-2">
            <div
              v-if="step != 3 && step != 0"
              class="title-text white--text text-start py-1"
              :class="captionStyle(step)"
            >
              {{ $t("tour_route") }}
            </div>

            <div
              class="title-text white--text text-start"
              :class="titleStyle(step)"
              :style="
                currentPoi.name.length > 3
                  ? 'font-size:25px;line-height: 35px'
                  : ''
              "
            >
              {{ currentPoi.name }}
            </div>
            <div
              class="title-text white--text text-start"
              :class="subTitleStyle(step)"
            >
              {{ $t("tour.station") }}
              {{ `${currentPoiIndex}/${pois.length} ` }}
            </div>
          </div>

          <button
            :style="step == 3 ? 'top: 7px' : ''"
            class="ml-auto mb-4 mr-5"
            @click="nextPoi"
          >
            <img
              src="@/assets/icons/next.svg"
              style="height: 18px; width: auto"
              :style="isLast ? 'opacity: 0.3' : ''"
            />
          </button>
        </div>
        <button
          v-if="$vuetify.breakpoint.xs"
          @click="beforeOpenAr"
          class="ar-button"
          :class="step == 3 ? 'shrinked' : ''"
        >
          <transition name="fade">
            <img
              v-if="currentPoi.has_ar"
              src="@/assets/icons/AR Button.svg"
              style="height: 60px; width: auto"
            />
          </transition>
        </button>

        <!-- title -->
        <!-- top controllers -->
      </template>

      <template #content="{ step }">
        <div
          v-if="step != 0 && !currentPoiChanged"
          class="text_background pa-10 d-flex flex-column align-center"
          :class="
            (step == 3 && $vuetify.breakpoint.xs) || step == 0
              ? 'expanded'
              : step == 3 && !$vuetify.breakpoint.xs
              ? 'web'
              : ''
              ? step == 1 || step == 2
              : ''
          "
        >
          <Audio
            v-if="currentPoi.sounds.length > 0"
            :audioFile="currentPoi.sounds"
            class="mb-4"
          />
          <TextSection
            :item="{
              paragraph: currentPoi.description,
              isLast: true,
            }"
            class="mb-8"
          ></TextSection>

          <Carousel
            v-if="currentPoi.images.length > 0"
            :images="currentPoi.images"
            :initialImage="currentPoi.images[0]"
          ></Carousel>
          <!-- <v-btn @click="$router.push('/model')">3d</v-btn> -->
        </div>
      </template>

      <template #bottomNavigation="{ step }">
        <transition name="fadeInUp">
          <div
            v-if="currentPoi.videos.length > 0"
            :class="
              $vuetify.breakpoint.xs
                ? 'bottom_navigation'
                : 'bottom_navigation web'
            "
            style="z-index: 999"
          >
            <button @click="dialog = true">
              <img
                v-if="step == 2 || step == 3"
                src="@/assets/icons/tour-close.svg"
                style="height: 55px; width: auto"
              />
            </button>
          </div>
        </transition>
      </template>
    </Card>
    <v-overlay z-index="999" v-model="dialog">
      <ModelDialog
        :model="currentPoi.videos"
        v-if="dialog"
        @close="dialog = false"
      />
    </v-overlay>

    <v-overlay z-index="999" v-model="arDialog">
      <ArDialog
        :currentPoi="currentPoi"
        v-if="arDialog"
        @close="arDialog = false"
        @openAr="openAr"
      />
    </v-overlay>
  </div>
</template>

<script>
import mapStyles from "@/utils/mapStyles.json";
import GmapCustomMarker from "vue2-gmap-custom-marker";
import Card from "@/components/Utils/Card.vue";
import Audio from "@/components/Utils/Audio.vue";
import { gmapApi } from "vue2-google-maps";
import TextSection from "@/components/Utils/TextSection.vue";
import Carousel from "@/components/Utils/Carousel.vue";
import ModelDialog from "@/components/Dialogs/ModelDialog.vue";
import ArDialog from "@/components/Dialogs/ArDialog.vue";
import { mapState } from "vuex";
import axios from "axios";
import { Device } from "@capacitor/device";
import { AppLauncher } from "@capacitor/app-launcher";

export default {
  components: {
    Card,
    TextSection,
    Carousel,
    ModelDialog,
    Audio,
    ArDialog,
    "gmap-custom-marker": GmapCustomMarker,
  },

  beforeRouteEnter(to, from, next) {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 1000);

    next();
  },

  async created() {
    try {
      // const res = await axios.get()
      // this.$route
      this.polyline = JSON.parse(this.currentTour.days[1].polyline);
      this.currentTour.days[1].pois.forEach((element) => {
        this.pois.push(element.poi);
      });
      await this.setCurrentPoi(this.pois[0].id);
      // await this.();
    } catch (e) {
      console.log(e);
    }
  },

  async mounted() {
    this.$nextTick(() => {
      this.map = this.$refs.mapRef;
    });

    setTimeout(async () => {
      if (
        this.currentTour.id != 8 &&
        this.currentTour.id != 16 &&
        this.currentTour.id != 17 &&
        this.currentTour.id != 18
      )
        return;
      this.getRoute();
    }, 300);
  },

  data() {
    return {
      polyline: [],
      currentPoiChanged: false,
      dialog: false,
      showModel: false,
      showCard: true,
      arDialog: false,
      mapOptions: {
        directionsService: null,
        directionsRenderer: null,
        zoomControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        keyboardShortcuts: false,
        gestureHandling: "greedy",
        minZoom: 8,
        maxZoom: 18,
        styles: mapStyles,
      },
      route: {},
      pois: [],
      currentPoi: null,
      map: null,
    };
  },

  computed: {
    ...mapState({
      currentTour: (state) => state.routes.currentTour,
      location: (state) => state.base.location,
      insets: (state) => state.base.insets,
    }),

    main() {
      return `top: calc(${
        this.insets?.top ? this.insets?.top + "px" : "0px"
      } + 0px)`;
    },

    buttontop() {
      return `margin-top: calc(${
        this.insets?.top ? this.insets?.top + "px" : "0px"
      })`;
    },

    titleinset() {
      return `margin-top: calc(${
        this.insets?.top ? this.insets?.top / 2 + "px" : "0px"
      } + 36px)`;
    },

    isFirst() {
      if (this.pois[0].id == this.currentPoi?.id) return true;
      else return false;
    },

    isLast() {
      if (this.pois.at(-1).id == this.currentPoi?.id) return true;
      else return false;
    },

    currentPoiIndex() {
      const index = this.pois.findIndex((el) => el.id == this.currentPoi?.id);
      return index + 1;
    },

    google: gmapApi,
  },

  methods: {
    async beforeOpenAr() {
      if (this.currentPoi.id == 66) this.arDialog = true;
      else await this.openAr(this.currentPoi.ar_uri);
    },

    async openAr(url) {
      const info = await Device.getInfo();
      if (info.platform == "ios") {
        const { value } = await AppLauncher.canOpenUrl({
          url: "unitydl://",
        });
        if (!value) {
          window.open(
            "https://apps.apple.com/gr/app/colonies-of-chalcidice-ar/id6479049809"
          );
        }

        await AppLauncher.openUrl({
          url,
        });
      } else if (info.platform == "android") {
        const { value } = await AppLauncher.canOpenUrl({
          url: "com.EfachagorAR",
        });
        if (!value) {
          window.open(
            "https://play.google.com/store/apps/details?id=com.EfachagorAR"
          );
        }
        await AppLauncher.openUrl({
          url,
        });
      }
    },
    async recenter() {
      try {
        this.$refs.mapRef.panTo({
          lat: this.location.latitude,
          lng: this.location.longitude,
        });
      } catch (e) {
        console.log(e);
      }
    },

    async previousPoi() {
      if (this.currentPoiIndex == 1) return;
      this.setCurrentPoi(this.pois[this.currentPoiIndex - 2].id);
    },

    async nextPoi() {
      if (this.currentPoiIndex == this.pois.length) return;

      this.setCurrentPoi(this.pois[this.currentPoiIndex].id);
    },

    async setCurrentPoi(id) {
      this.currentPoiChanged = true;
      const res = await axios.get(`${process.env.VUE_APP_BASE_URL}/pois/${id}`);
      this.currentPoi = res.data.poi;
      this.currentPoiChanged = false;
    },

    async getRoute() {
      try {
        const waypoints = this.pois
          .map((poi, i) => {
            if (i != 0 && i != this.pois.length - 1)
              return {
                location: {
                  lat: parseFloat(poi.latitude),
                  lng: parseFloat(poi.longitude),
                },
                stopover: true,
              };
          })
          .slice(1, -1);

        const directionsService = new this.google.maps.DirectionsService();

        const directionsRenderer = new this.google.maps.DirectionsRenderer({
          suppressMarkers: true,
          polylineOptions: {
            strokeColor: "black",
          },
        });

        directionsRenderer.setMap(this.$refs.mapRef.$mapObject);

        directionsService
          .route({
            origin: {
              lat: parseFloat(this.pois[0].latitude),
              lng: parseFloat(this.pois[0].longitude),
            },
            destination: {
              lat: parseFloat(this.pois[this.pois.length - 1].latitude),
              lng: parseFloat(this.pois[this.pois.length - 1].longitude),
            },
            waypoints: waypoints,
            travelMode: this.google.maps.TravelMode.WALKING,
          })
          .then((response) => {
            directionsRenderer.setDirections(response);
            let distance = 0;
            for (const leg of response.routes[0].legs) {
              distance += leg.distance.value;
            }
            this.distance = (distance / 1000).toFixed(1) + "km";
          })
          .catch((e) => console.log("Directions request failed due to ", e));
      } catch (e) {
        console.log(e);
      }
    },

    // styling

    mapStyle(step) {
      if (this.showCard) {
        if (step == 3 && !this.$vuetify.breakpoint.xs) return "googleMap";
        if (step == 0) return "googleMap bottom";
        else return "googleMap shrinked";
      }
      return "googleMap";
    },

    mapContainer(step) {
      if (this.showCard) {
        if (step == 3 && !this.$vuetify.breakpoint.xs) return "map-container";

        if (step == 0) return "map-container bottom";
        else return "map-container shrinked";
      }
      return "map-container";
    },
    titleContainerStyle(step) {
      if (step == 3 && !this.$vuetify.breakpoint.xs)
        return "title-container web";
      if (step == 3 || step == 0) return "title-container shrinked";
      return "title-container";
    },

    backgroundImageStyle(step) {
      if (step == 3 || step == 0) return "background-image shrinked";
      return "background-image ";
    },

    titleStyle(step) {
      if (step == 3 || step == 0) {
        return "route_title shrinked";
      }
      return "route_title";
    },

    subTitleStyle(step) {
      if (step == 3 || step == 0) {
        return "route_subtitle shrinked";
      }
      return "route_subtitle";
    },

    captionStyle(step) {
      return "route_caption";
    },

    // styling

    onOpenMap() {
      this.$router.push(`/routes/pois`);
    },
  },
};
</script>

<style scoped>
.title-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -35%);
  width: 90vw;
}

.title-container.shrinked {
  transform: translate(-50%, -60%);
}

.title-container.web {
  position: relative;
  top: 20px;
  left: 0;
  transform: translate(0, 0);
  width: 30vw;
}

.route_title {
  font-weight: 400;
  font-size: 32px;
  transition: font-size 0.5s ease;
  line-height: 50px;
  text-align: left;
  /* margin-top: 50px; */
  /* white-space: nowrap; */
}

.route_title.shrinked {
  font-size: 23px;
  line-height: 30px;
  margin-bottom: 10px;
}

.route_subtitle {
  font-weight: 300;
  font-size: 23px;
  transition: font-size 0.5s ease;
  line-height: 40px;
  white-space: nowrap;
}

.route_subtitle.shrinked {
  margin-bottom: 24px;
  font-size: 14px;
  font-weight: 300;
  overflow-x: visible;
  line-height: 14px;
}

.route_caption {
  font-weight: 250;
  font-size: 18px;
  transition: font-size 0.5s ease;
  white-space: nowrap;

  /* line-height: 30px; */
}

.map-container {
  position: fixed;
  top: 0;
  z-index: 1;
  width: 100vw;
  height: 100vh;
  max-height: 100vh;
  transition: all 0.6s ease;
}

.map-container.shrinked {
  height: 50vh;
}

.text_background.expanded {
  margin-top: 160px;
}

.text_background.web {
  margin-top: 100px;
}

.googleMap {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  z-index: 0;
  height: 100vh;
  transition: all 0.6s ease;
}
.map-container.bottom {
  height: 85vh;
}

.googleMap.shrinked {
  height: 56vh;
}

@keyframes fadeInUp {
  from {
    transform: translate3d(0, 89px, 0);
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

.fadeInUp-enter-active {
  animation: fadeInUp 0.6s ease;
  transition: opacity 0.6s ease;
}
.fadeInUp-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.poi-header {
  position: absolute;
  top: 100px;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100vw;
  padding: 10px;
  background-color: white;
  font-weight: 500;
  font-size: 18px;
}

.bottom_navigation {
  position: fixed;
  bottom: 15px;
  right: 15px;
  border-top-left-radius: 35px;
  border-top-right-radius: 35px;
}

.bottom_navigation.web {
  position: absolute;
}

.ar-button {
  position: absolute;
  bottom: -37px;
  right: 50px;
  transition: all 0.6s ease;
  overflow: visible !important;
}

.ar-button.shrinked {
  position: absolute;
  bottom: -35px;
  right: 50px;
  z-index: 999;
}
</style>
